import {
  ReadDisclosureRequest,
  DisclosureServiceClient,
  FetchDisclosureRequest,
  ReadDisclosureByIdRequest,
  SaveClientDisclosureRequest,
} from '../proto/reportpb/disclosure_grpc_web_pb';
import { auth } from '../lib/auth/Auth';
import {
  DisclosureServiceClient as AdmDisclosureServiceClient,
  DownloadBlankReportRequest,
} from '../proto/admpb/disclosure_grpc_web_pb';
import { Empty } from '../google/protobuf/empty_pb';
import download from './DownloadService';

const service = new DisclosureServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });
const admService = new AdmDisclosureServiceClient(
  window.env.GRPC_ENDPOINT,
  {},
  { ...auth }
);
export async function readDisclosure(reportType, correspondent) {
  return new Promise((resolve, reject) => {
    let req = new ReadDisclosureRequest();
    req.setReportType(reportType);
    req.setCorrespondent(correspondent);

    service.readDisclosure(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function fetchDisclosures(userId, correspondent) {
  return new Promise((resolve, reject) => {
    let req = new FetchDisclosureRequest();
    req.setCorrespondent(correspondent);
    req.setUserId(userId);

    service.fetchDisclosures(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function readDisclosureById(disclosureId) {
  return new Promise((resolve, reject) => {
    let req = new ReadDisclosureByIdRequest();
    req.setDisclosureId(disclosureId);

    service.readDisclosureById(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function saveClientDisclosure(disclosures) {
  return new Promise((resolve, reject) => {
    let req = new SaveClientDisclosureRequest();
    req.setDisclosureIdList(disclosures);

    service.saveClientDisclosure(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function downloadBlankReport(param, disclosure) {
  return new Promise((resolve, reject) => {
    const req = new DownloadBlankReportRequest();

    req.setCorrespondent(param.correspondent);
    req.setReportType(param.reportType);
    req.setDisclosure(disclosure);

    admService.downloadBlankReport(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        download(response);
        resolve(response.toObject());
      }
    });
  });
}

export const getClientNoticeDisclosure = async () => {
  return new Promise((resolve, reject) => {
    const req = new Empty();

    admService.getClientNoticeDisclosure(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
};
